/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseNotificationsApi } from '../../base-api';
export type NotificationUserInfoFragment = { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type NotificationFragment = { __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } };

export type WebhookConfigurationFragment = { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, groupId?: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: Types.WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type CreateWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfiguration: Types.CreateWebhookConfigurationInput;
}>;


export type CreateWebhookConfigurationMutation = { __typename: 'Mutation', createWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfigurationId: Types.Scalars['String']['input'];
  webhookConfiguration: Types.UpdateWebhookConfigurationInput;
}>;


export type UpdateWebhookConfigurationMutation = { __typename: 'Mutation', updateWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type DeleteWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfigurationId: Types.Scalars['String']['input'];
}>;


export type DeleteWebhookConfigurationMutation = { __typename: 'Mutation', deleteWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateNotificationReadStatusMutationVariables = Types.Exact<{
  notificationId: Types.Scalars['String']['input'];
  readStatus: Types.Scalars['Boolean']['input'];
}>;


export type UpdateNotificationReadStatusMutation = { __typename: 'Mutation', updateNotificationReadStatus: { __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } } };

export type ReadAllNotificationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.NotificationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllNotificationsQuery = { __typename: 'Query', readAllNotifications: { __typename: 'PaginatedNotificationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } }> } };

export type UnreadNotificationsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename: 'Query', readAllNotifications: { __typename: 'PaginatedNotificationResponseType', itemCount: number } };

export type ReadAllWebhookConfigurationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.WebhookConfigurationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllWebhookConfigurationsQuery = { __typename: 'Query', readAllWebhookConfigurations: { __typename: 'PaginatedWebhookConfigurationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, groupId?: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: Types.WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadAllowedWebhookModelKeysQueryVariables = Types.Exact<{
  webhookEventsEnum: Types.WebhookEventsEnum;
}>;


export type ReadAllowedWebhookModelKeysQuery = { __typename: 'Query', readAllowedWebhookModelKeys: Array<string> };

export type ReadWebhookEventsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadWebhookEventsQuery = { __typename: 'Query', readWebhookEvents: Array<Types.WebhookEventsEnum> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const NotificationFragmentDoc = new TypedDocumentString(`
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}
    `, {"fragmentName":"Notification"});
export const NotificationUserInfoFragmentDoc = new TypedDocumentString(`
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
    `, {"fragmentName":"NotificationUserInfo"});
export const WebhookConfigurationFragmentDoc = new TypedDocumentString(`
    fragment WebhookConfiguration on WebhookConfigurationResponseType {
  __typename
  webhookConfigurationId
  groupId
  name
  description
  creationTimestamp
  creationUser {
    __typename
    ...NotificationUserInfo
  }
  creationUserId
  event
  gatewayId
  secretId
  destinationUrl
  payloadMapping
  objectVersion
}
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"WebhookConfiguration"});
export const CreateWebhookConfigurationDocument = new TypedDocumentString(`
    mutation CreateWebhookConfiguration($webhookConfiguration: CreateWebhookConfigurationInput!) {
  __typename
  createWebhookConfiguration(webhookConfiguration: $webhookConfiguration) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const UpdateWebhookConfigurationDocument = new TypedDocumentString(`
    mutation UpdateWebhookConfiguration($webhookConfigurationId: String!, $webhookConfiguration: UpdateWebhookConfigurationInput!) {
  __typename
  updateWebhookConfiguration(
    webhookConfigurationId: $webhookConfigurationId
    input: $webhookConfiguration
  ) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const DeleteWebhookConfigurationDocument = new TypedDocumentString(`
    mutation DeleteWebhookConfiguration($webhookConfigurationId: String!) {
  __typename
  deleteWebhookConfiguration(webhookConfigurationId: $webhookConfigurationId) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const UpdateNotificationReadStatusDocument = new TypedDocumentString(`
    mutation UpdateNotificationReadStatus($notificationId: String!, $readStatus: Boolean!) {
  __typename
  updateNotificationReadStatus(
    notificationId: $notificationId
    readStatus: $readStatus
  ) {
    __typename
    ...Notification
  }
}
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}`);
export const ReadAllNotificationsDocument = new TypedDocumentString(`
    query ReadAllNotifications($filter: NotificationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllNotifications(filters: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...Notification
    }
  }
}
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}`);
export const UnreadNotificationsCountDocument = new TypedDocumentString(`
    query UnreadNotificationsCount {
  __typename
  readAllNotifications(filters: {consoleConfiguration: {readStatus: {ne: true}}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadAllWebhookConfigurationsDocument = new TypedDocumentString(`
    query ReadAllWebhookConfigurations($filter: WebhookConfigurationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllWebhookConfigurations(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...WebhookConfiguration
    }
  }
}
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment WebhookConfiguration on WebhookConfigurationResponseType {
  __typename
  webhookConfigurationId
  groupId
  name
  description
  creationTimestamp
  creationUser {
    __typename
    ...NotificationUserInfo
  }
  creationUserId
  event
  gatewayId
  secretId
  destinationUrl
  payloadMapping
  objectVersion
}`);
export const ReadAllowedWebhookModelKeysDocument = new TypedDocumentString(`
    query ReadAllowedWebhookModelKeys($webhookEventsEnum: WebhookEventsEnum!) {
  __typename
  readAllowedWebhookModelKeys(webhookEventsEnum: $webhookEventsEnum)
}
    `);
export const ReadWebhookEventsDocument = new TypedDocumentString(`
    query ReadWebhookEvents {
  __typename
  readWebhookEvents
}
    `);

const injectedRtkApi = baseNotificationsApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateWebhookConfiguration: build.mutation<Types.CreateWebhookConfigurationMutation, Types.CreateWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: CreateWebhookConfigurationDocument as unknown as string, variables })
    }),
    UpdateWebhookConfiguration: build.mutation<Types.UpdateWebhookConfigurationMutation, Types.UpdateWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: UpdateWebhookConfigurationDocument as unknown as string, variables })
    }),
    DeleteWebhookConfiguration: build.mutation<Types.DeleteWebhookConfigurationMutation, Types.DeleteWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: DeleteWebhookConfigurationDocument as unknown as string, variables })
    }),
    UpdateNotificationReadStatus: build.mutation<Types.UpdateNotificationReadStatusMutation, Types.UpdateNotificationReadStatusMutationVariables>({
      query: (variables) => ({ document: UpdateNotificationReadStatusDocument as unknown as string, variables })
    }),
    ReadAllNotifications: build.query<Types.ReadAllNotificationsQuery, Types.ReadAllNotificationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllNotificationsDocument as unknown as string, variables })
    }),
    UnreadNotificationsCount: build.query<Types.UnreadNotificationsCountQuery, Types.UnreadNotificationsCountQueryVariables | void>({
      query: (variables) => ({ document: UnreadNotificationsCountDocument as unknown as string, variables })
    }),
    ReadAllWebhookConfigurations: build.query<Types.ReadAllWebhookConfigurationsQuery, Types.ReadAllWebhookConfigurationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllWebhookConfigurationsDocument as unknown as string, variables })
    }),
    ReadAllowedWebhookModelKeys: build.query<Types.ReadAllowedWebhookModelKeysQuery, Types.ReadAllowedWebhookModelKeysQueryVariables>({
      query: (variables) => ({ document: ReadAllowedWebhookModelKeysDocument as unknown as string, variables })
    }),
    ReadWebhookEvents: build.query<Types.ReadWebhookEventsQuery, Types.ReadWebhookEventsQueryVariables | void>({
      query: (variables) => ({ document: ReadWebhookEventsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateWebhookConfigurationMutation, useUpdateWebhookConfigurationMutation, useDeleteWebhookConfigurationMutation, useUpdateNotificationReadStatusMutation, useReadAllNotificationsQuery, useLazyReadAllNotificationsQuery, useUnreadNotificationsCountQuery, useLazyUnreadNotificationsCountQuery, useReadAllWebhookConfigurationsQuery, useLazyReadAllWebhookConfigurationsQuery, useReadAllowedWebhookModelKeysQuery, useLazyReadAllowedWebhookModelKeysQuery, useReadWebhookEventsQuery, useLazyReadWebhookEventsQuery } = injectedRtkApi;

